<template>

	<div :class="{'hide': loading}">
		<div :class="{'spinner loading': loading}"></div>


		<div class="comment-list">

			<h3 v-if="$user.isWriter()">Message to Customer</h3>
			<h3 v-else>Message to Writer</h3>

			<!-- COMMENT REPLY -->
			<div class="comment-wrap comment-reply">
				<!-- USER AVATAR -->
				<a href="/customer/dashboard/profile">
					<figure class="user-avatar medium">
						<img :src="'/images/avatars/'+$user.avatar()" alt="">
					</figure>
				</a>
				<!-- /USER AVATAR -->

				<!-- COMMENT REPLY FORM -->
				<form method="POST" enctype="multipart/form-data" class="comment-form" id="comment-form" action="/">
					<textarea v-model="body" ref='body' name="body" placeholder="Write your comment here..." style="margin-bottom: 5px;"></textarea>

					<button @click.prevent="validate()" type="submit" class="button primary">Send Message</button>

					<button v-if="$user.can('deliver', 'orderPolicy', order)" @click.prevent="showDeliverModal()" href="/" class="button primary open-popup-form">Deliver Paper</button>

					<button v-if="$user.can('dispute', 'orderPolicy', order)" @click.prevent="showDisputeModal()" href="/" class="button dark-light open-popup-form">Open Dispute</button>

					<a v-if="$user.can('requestRevision', 'orderPolicy', order)" @click.prevent="showRequestRevisionModal()" href="/" class="icon revision tooltip"
					   title="Request revision (available for 30 days after the deadline)"><i class="fa fa-repeat" aria-hidden="true"></i>
					</a>

					<a v-if="$user.can('approve', 'orderPolicy', order)" @click.prevent="showApproveModal()" href="/" class="icon approve tooltip" title="Approve order"><i class="fa fa-check" aria-hidden="true"></i></a>

					<label class="file" :title="attachFileTitle">
						<input id="file" v-on:change="handleFileUploads()" ref="files" name="file[]" type="file" multiple />
					</label>

				</form>
				<!-- /COMMENT REPLY FORM -->
			</div>
			<!-- /COMMENT REPLY -->

			<div v-for="comment in comments">

				<order-placed v-if="comment.type_name == 'Order Started'" :comment="comment" :order="order"></order-placed>

				<regular-comment v-if="comment.type_name == 'Regular' || comment.type_name == 'Bidding comment'" :comment="comment" :order="order"></regular-comment>

				<confirmation v-if="comment.type_name == 'Confirmation'" :comment="comment" :order="order"></confirmation>

				<delivered v-if="comment.type_name == 'Deliver'" :comment="comment" :order="order"></delivered>

				<revision v-if="comment.type_name == 'Revision'" :comment="comment" :order="order"></revision>

				<revision-decline v-if="comment.type_name == 'Decline Revision'" :comment="comment"></revision-decline>

				<approve v-if="comment.type_name == 'Approve'" :comment="comment"></approve>

				<dispute v-if="comment.type_name == 'Dispute'" :order="order" :comment="comment"></dispute>

				<extension v-if="comment.type_name == 'Extension'" :comment="comment"></extension>

				<writer-extension v-if="comment.type_name == 'Writer Extension' && !$user.isCustomer()" :comment="comment"></writer-extension>



			</div>

			<paginator :dataSet="commentsDataSet" @changed="fetch"></paginator>

			<div class="clearfix"></div>


		</div>


	</div>
</template>


<script>
    import { required, email, helpers, minLength, sameAs, between } from 'vuelidate/lib/validators'

    import RegularComment from './Comments/RegularComment.vue'
    import OrderPlaced from './Comments/OrderPlaced.vue'
    import Confirmation from './Comments/Confirmation.vue'
    import Delivered from './Comments/Delivered.vue'
    import Revision from './Comments/Revision.vue'
    import RevisionDecline from './Comments/RevisionDecline.vue'
    import Approve from './Comments/Approve.vue'
    import Dispute from './Comments/Dispute.vue'
    import Extension from './Comments/Extension.vue'
    import WriterExtension from './Comments/WriterExtension.vue'

    // const alpha = helpers.regex('alpha', /^[a-zA-Z]*$/)


    export default {

        components: {
            'regular-comment': RegularComment,
            'order-placed': OrderPlaced,
            'confirmation': Confirmation,
            'delivered': Delivered,
            'revision': Revision,
            'revision-decline': RevisionDecline,
            'approve': Approve,
            'dispute': Dispute,
            'extension': Extension,
            'writer-extension': WriterExtension,
        },

        props: ['order'],
        data() {
            return {
                body: '',
                files: '',
                loading: true,
                commentsDataSet: false,
                comments: false,
                attachFileTitle: 'Attach File'
            }
        },

        validations: {
            body: {
                allowed(body) {
                    return (
                        /^(?!.*\$).*$/.test(body) && // checks for a-z
                        /^(?!.*\bdolar\b).*$/.test(body) && // checks for a-z
                        /^(?!.*\bdollar\b).*$/.test(body) && // checks for a-z
                        /^(?!.*\bDollar\b).*$/.test(body) && // checks for a-z
                        /^(?!.*\bdolars\b).*$/.test(body) && // checks for a-z
                        /^(?!.*\bdollars\b).*$/.test(body) && // checks for a-z
                        /^(?!.*\bDollars\b).*$/.test(body) // checks for a-z
                    );

                },

			},

        },


        created(){

            // this.fetch();
            this.$eventBus.$on('fetchComments', this.fetch);
            this.$eventBus.$on('refreshComments', this.fetch);
        },

        methods: {

            fetch(page) {
                this.loading = true;
                axios.get(this.url(page)).then(this.refresh);
            },

            url(page) {

                 return `/api/comments?filter[order_id]=${this.order.id}&filter[order_comments]=true&include=user,files,commentable&page=${page}`;

            },

            refresh({data}) {
                this.commentsDataSet = data;

                //if we receive paginated collection - we user data.data if not - just data.
                this.comments = data.data ? data.data : data;
                this.loading = false;
            },

            handleFileUploads(){
                this.files = this.$refs.files.files;
                this.attachFileTitle = this.files[0].name;
            },

            sendMessage() {

                const config = { headers: { 'Content-Type': 'multipart/form-data' } };

                //Form request will be used for POST request to allow multiple file uploads.
                let formData = new FormData();
                formData.append('order_id', this.order.hashId);
                formData.append('body', this.body);

                //Iteration over files in input.
                for( var i = 0; i < this.files.length; i++ ){
                    formData.append('file[' + i + ']', this.files[i], this.files[i].name);
                }


                if (this.body || this.files) {

                    this.loading = true;
                    axios.post('/api/comments/', formData, config)
                        .then(({data}) => {
//                        this.$eventBus.$on('fetch');
                            flash(data.flash);
                            this.fetch();
                            this.body = '';
                            this.files = '';
                            this.attachFileTitle = 'Attach files';
                        }).catch(error => {
                        if (error.response) {
                            if(error.response.status === 413) {
                                flash('File is too large', 'error');
                            }
                            else {
                                flash('Given data was invalid', 'error');
                            }
                        }
                        else {
                            flash('Given data was invalid', 'error');
                        }
                        this.fetch();
                        this.loading = false;

                    });

                }
            },

            validate() {
                this.$v.$touch();

                const invalidFields = Object.keys(this.$v.$params).filter(fieldName => this.$v[fieldName].$invalid);

                if (invalidFields) {

                    if(this.$v.body.$error && this.$user.isWriter() && !this.$user.isEditor()) {
                            this.$refs['body'].focus();
                        // flash('Do not mention your price when talking to clients! We recommend placing higher bids or ask for additional pages.', 'error');
                        this.sendMessage();

                    } else {
                        this.sendMessage();
                    }
                } else {
                    this.sendMessage();
                }



            },



            showRequestRevisionModal() {
                this.$modal.show('requestRevisionModal',{ order: this.order})
            },
            showApproveModal() {
                this.$modal.show('approveModal',{ order: this.order})
            },
            showDeliverModal() {
                this.$modal.show('deliverModal',{ order: this.order})
            },
            showDisputeModal() {
                this.$modal.show('disputeModal',{ order: this.order})
            },




        },


    }
</script>